import { CartProductDto } from '../../dto/cartProduct.dto';

export interface PosBundleDialogResult {
  selectedCartProduct?: CartProductDto;
  cartProducts?: CartProductDto[];
  isBundleProductMultiSelection?: boolean;
  selectedSaleUnitCartId?: number;
  selectedSaleUnitCartSplitId?: number;
  splitProductQuantity?: number;
}
